import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Stack,
  FormControlLabel,
  Checkbox,
  Alert,
} from "@mui/material";
import { ADJUSTMENT_FORM } from "../copy/opsDescriptions.js";

const TYPES = ["DAMAGE", "LOST_ITEM", "REFUND", "DISCOUNT", "OTHER"];
const RESPONSIBILITIES = ["PROVIDER", "BUBAKII", "SHARED"];

export default function AdjustmentForm({ open, onClose, onSubmit, loading = false }) {
  const [form, setForm] = useState({
    type: "DAMAGE",
    amount: "",
    reason: "",
    responsibility: "PROVIDER",
    providerSharePercent: 50,
    allowOverride: false,
  });

  const handleChange = (field) => (e) => {
    const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    onSubmit?.({
      type: form.type,
      amount: Number(form.amount),
      reason: form.reason.trim(),
      responsibility: form.responsibility,
      providerSharePercent:
        form.responsibility === "SHARED" ? Number(form.providerSharePercent) : undefined,
      allowOverride: form.allowOverride,
    });
  };

  const handleClose = () => {
    if (!loading) onClose?.();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{ADJUSTMENT_FORM.title}</DialogTitle>
      <DialogContent>
        <Alert severity="info" sx={{ mt: 1, mb: 1 }}>
          {ADJUSTMENT_FORM.intro}
        </Alert>
        <Stack spacing={2}>
          <TextField select label="Type" value={form.type} onChange={handleChange("type")} fullWidth>
            {TYPES.map((t) => (
              <MenuItem key={t} value={t}>
                {t.replace(/_/g, " ")}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            label="Amount (ZAR)"
            type="number"
            inputProps={{ min: 0, step: 0.01 }}
            value={form.amount}
            onChange={handleChange("amount")}
            fullWidth
            required
          />
          <TextField
            label="Reason"
            value={form.reason}
            onChange={handleChange("reason")}
            fullWidth
            required
            multiline
            minRows={2}
          />
          <TextField
            select
            label="Responsibility"
            value={form.responsibility}
            onChange={handleChange("responsibility")}
            fullWidth
            helperText="PROVIDER / SHARED creates partner recovery on approve"
          >
            {RESPONSIBILITIES.map((r) => (
              <MenuItem key={r} value={r}>
                {r}
              </MenuItem>
            ))}
          </TextField>
          {form.responsibility === "SHARED" && (
            <TextField
              label="Provider share %"
              type="number"
              inputProps={{ min: 0, max: 100 }}
              value={form.providerSharePercent}
              onChange={handleChange("providerSharePercent")}
              fullWidth
            />
          )}
          <FormControlLabel
            control={
              <Checkbox checked={form.allowOverride} onChange={handleChange("allowOverride")} />
            }
            label="Override lookback limit (exceptional late cases)"
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={loading || !form.amount || !form.reason.trim()}
        >
          Create (pending approval)
        </Button>
      </DialogActions>
    </Dialog>
  );
}
